import { Structure, t, TLabel } from "util/stdtypes";
import { DashboardConfig, DashboardSideNavScreen } from "component/dashboard";

export type EditorialDashTab = {
    label: TLabel;
    component: React.ComponentType;
}

export type EditorialDashConfig = DashboardConfig & {
}

// Editorial Dash is just a container for tabs. All the important stuff
// happens in the feature modules that add tabs.
export const EditorialDashStructure : Structure<EditorialDashConfig> = {
    key: 'editorialdash',
    name: 'Editorial Dashboard',
    screen: DashboardSideNavScreen,
    isAdminUi: true,
    receivesConfigDefaults: {
        dashboardTabs: [],
        dashboardTitleLabel: t('Editorial Dashboard'),
        dashboardCapability: 'content/spaces',
    },
}
